/* eslint-disable max-len */
// @flow
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Card,
  Row,
  Col,
} from 'antd';
import { useLocation } from 'react-router-dom';

import styled from 'styled-components';
import formatNumber from 'utils/formatNumber';
import Loading from 'components/Loading';
import moment from 'moment-timezone';
import {
  PAGES,
  MESSAGES,
} from 'appconstants';
import {
  notificationActions,
} from 'store/actions';
import { NOTIFICATION } from 'store/actionTypes';
import { API_END_POINTS, axiosAuthInstance } from 'api';

import {
  SpH5,
  SpText,
  SpForm,
} from 'components/DesignKit';

// $FlowFixMe
const StatusTag = styled('div')({
  display: 'inline-block',
  paddingLeft: '10px',
  paddingRight: '10px',
  borderRadius: '10px',
  height: '21px',
  marginLeft: 'auto',
  marginRight: 'auto',
  fontWeight: 600,
  minWidth: '75px',
  textAlign: 'center',
});

type Props = {
  test: boolean,
  history: {
    push: Function,
  },
  match: {
    params: Object,
  },
  selectedAccount: Object,
  setNotification: Function,
}

const TransactionsDetails = (props: Props) => {
  const {
    test,
    history,
    selectedAccount,
    setNotification,
  } = props;
  const { gid } = props.match.params;
  const location = useLocation();
  const gidPath = gid.split('-')[1];
  const currencyType = selectedAccount && selectedAccount.currency;
  const [paymentDetails, setPaymentDetails] = useState({});
  const [loader, setLoader] = useState(false);

  const getData = async () => {
    setLoader(true);
    try {
      const { data: { entity } } = await axiosAuthInstance
        .get(`${API_END_POINTS.MANUAL_TRANSACTION}/${gid}`);
      setPaymentDetails(entity);
      console.log(entity, 'entityentityentityentity');
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e?.response?.data?.message || MESSAGES.API_ERROR,
      });
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!gidPath) {
      history.push(PAGES.PAYMENTS_TRANSACTIONS);
    }
  }, []);

  useEffect(() => {
    getData();
  }, [test, selectedAccount, location]);

  if (loader) {
    return <Loading />;
  }
  return (
    <>
      {
        paymentDetails?.gid && (
          <>
            <Card className="mb-3">
              <Row type="flex" className="my-2 mb-3">
                <Col className="d-flex align-items-center">
                  <SpText className="mr-3" fontSize="20px" fontWeight="600">
                    {paymentDetails?.transaction?.amount < 0
                      ? `(${paymentDetails?.transaction?.currency?.prefix}
                      ${formatNumber((paymentDetails?.transaction?.amount / 100).toFixed(paymentDetails?.transaction?.currency?.toFixed).replace(/-/g, ''), currencyType)})`
                      : `${paymentDetails?.transaction?.currency?.prefix}
                      ${formatNumber((paymentDetails?.transaction?.amount / 100).toFixed(paymentDetails?.transaction?.currency?.toFixed), currencyType)}`}
                  </SpText>
                  <StatusTag style={{ backgroundColor: '#EAEBFF', color: '#4C51C2' }}>
                    Force Credited
                  </StatusTag>
                </Col>
              </Row>
              <SpForm>
                <Row type="flex" justify="start">
                  <Col span={4}>
                    <span>Date/Time</span>
                  </Col>
                  <Col span={9}>
                    <SpH5>
                      {
                        paymentDetails?.createdAt
                          ? `${moment.utc(paymentDetails.createdAt).tz(selectedAccount.timezone).format('MMM DD, YYYY hh:mm a')}` : <>&#8211;</>
                      }
                    </SpH5>
                  </Col>
                </Row>
                <Row type="flex" justify="start">
                  <Col span={4}>
                    <span>Auth Code</span>
                  </Col>
                  <Col span={9}>
                    <SpH5>{paymentDetails.authCode ? paymentDetails.authCode : <>&#8211;</>}</SpH5>
                  </Col>
                </Row>
                <Row type="flex" justify="start">
                  <Col span={4}>
                    <span>Card Type</span>
                  </Col>
                  <Col span={9}>
                    <SpH5>{paymentDetails.cardType ? paymentDetails.cardType : <>&#8211;</>}</SpH5>
                  </Col>
                </Row>
                <Row type="flex" justify="start">
                  <Col span={4}>
                    <span>Card Brand</span>
                  </Col>
                  <Col span={9}>
                    <SpH5>{paymentDetails.cardBrand ? paymentDetails.cardBrand : <>&#8211;</>}</SpH5>
                  </Col>
                </Row>
                <Row type="flex" justify="start">
                  <Col span={4}>
                    <span>Card Last 4</span>
                  </Col>
                  <Col span={9}>
                    <SpH5>{paymentDetails.last4 ? paymentDetails.last4 : <>&#8211;</>}</SpH5>
                  </Col>
                </Row>
              </SpForm>
            </Card>
          </>
        )
      }
    </>
  );
};
const mapStateToProps = (state) => ({
  test: state.account.test,
  selectedAccount: state.account.selectedAccount,
  submitting: state.loading.submitting,
});

const mapDispatchToProps = (dispatch) => ({
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(TransactionsDetails);
